<template>
<div class="x_box">
    <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item">
                <router-link to="/sale/exchanges">{{ $t('sale_exchange') }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">{{ $t('create_new') }}</li>
        </ol>
    <div class="x_header">
        <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)">
            <i class="fa fa-arrow-circle-o-left"/> {{ $t('back') }}
        </button>
        <b-btn variant="outline-primary no-bor" size="sm" @click="onSave">
            <i class="fa fa-floppy-o" aria-hidden="true"/> {{$t('save')}}
        </b-btn>
    </div>
    <div class="x_body">
        <div class="card f_card">
            <div class="card-body">
                <div class="row">
                    <div class="col-sm-2">
                        <div class="form-group">
                            <label class="control-label blue">{{ $t('customer') }}</label>
                            <div>
                                <CustomerDropdown @select="customerSelected" :value="header.CustomerName" />
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-2">
                        <div class="form-group">
                            <label class="control-label blue">{{ $t('stock') }}</label>
                            <div>
                                <select class="form-control form-control-sm" v-model="header.BranchId">
                                    <option v-for="ret in branchs" value="ret.Id" :key="ret.Id">{{ret.Name}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-2">
                        <div class="form-group">
                            <label class="control-label blue">{{ $t('date') }}</label>
                            <div>
                                <input type="date" class="form-control form-control-sm" v-model="date" />
                            </div>
                        </div>
                    </div>
                </div>
                <hr>
                <div class="row">
                    <div class="col-sm-12">
                        <table class="grid">
                            <thead>
                                <tr>
                                    <th style="width: 30px;"></th>
                                    <th>{{$t('item_name')}}</th>
                                    <th style="width: 120px;">{{$t('uom')}}</th>
                                    <th style="width: 120px;">{{$t('qty')}}</th>
                                    <th style="width: 120px;">ចំនួនបង្វិល</th>
                                    <th style="width: 120px;">{{$t('cost')}}</th>
                                    <th style="width: 120px;">{{$t('discount')}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(ret,index) in lines" :key="ret.Id">
                                    <td style="width: 30px;">
                                        <button type="button" class="btn btn-danger btn-remove" @click="removeLine(index)">X</button>
                                    </td>
                                    <td>
                                        <AuthCompleted @select="itemSelect($event, ret)" :value="ret.ItemName"/>
                                    </td>
                                    <td>
                                        <UomDropdown :value="ret.UomName" :item_id="ret.ItemId" @select="uomChange($event, ret)"></UomDropdown>
                                    </td>
                                    <td class="text-center">
                                        <input type="number" class="form-control form-control-sm" v-model="ret.Quantity" @keypress="$isKeyNumber" @change="reCalculate" />
                                    </td>
                                    <td class="text-center">
                                        <input type="number" v-model = "ret.NoneQuantity" @keypress="$isKeyNumber" class="form-control form-control-sm" />
                                    </td>
                                    <td class="text-right">
                                        <input type="number" class="form-control form-control-sm" v-model="ret.Cost" @keypress="$isKeyNumber" @change="reCalculate" />
                                    </td>
                                    <td class="text-right">
                                        <input type="number" class="form-control form-control-sm" v-model="ret.Discount" @keypress="$isKeyNumber" @change="reCalculate" />
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th rowspan="3" style="width: 30px;"></th>
                                    <th colspan="2" rowspan="3" style="vertical-align:top;"><button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="addLine"><i class="fa fa-plus"/> {{ $t('add_line') }}</button></th>
                                    <th colspan="3" class="text-right">សរុបទាំងអស់:</th>
                                    <th class="text-right"><input type="text" class="form-control form-control-sm text-right" :value="$money(header.TotalAmount)" readonly /></th>
                                </tr>
                                <tr>
                                    <th colspan="3" class="text-right">ចុះថ្លៃ:</th>
                                    <th class="text-right">
                                        <input type="text" class="form-control form-control-sm text-right" v-model="header.Discount" @change="reCalculate" />
                                    </th>
                                </tr>
                                <tr>
                                    <th colspan="3" class="text-right">សរុបចុងក្រោយ:</th>
                                    <th class="text-right">
                                        <input type="text" class="form-control form-control-sm text-right" v:value="$money(header.PaidAmount)" readonly />
                                    </th>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
    import { AuthCompleted } from '../Item';
    import UomDropdown from '../UOM/Dropdown';
    import { CustomerDropdown } from '../Customer';
    export default {
        components: {
            AuthCompleted,
            UomDropdown,
            CustomerDropdown
        },
        data: function(){
            return {
                header: {
                    CustomerId: '',
                    CustomerName: '',
                    Discount: 0,
                    Deposit: 0,
                    TotalAmount: 0,
                    PaidAmount: 0,
                    Contact: '',
                    Num: ''
                },
                lines: [{
                    Checked: false,
                    ItemId: '',
                    ItemName: '',
                    UomId: '',
                    UomName: '',
                    Quantity: 1,
                    NoneQuantity: 0,
                    Cost: 0,
                    Discount: 0,
                    SubTotal: 0
                }],
                date: this.$now().format('YYYY-MM-DD'),
                due_date: this.$now().format('YYYY-MM-DD'),
                actionLink: 'sale/exchange/save',
                branchs: []
            }
        },
        created: function(){
            let id = this.$route.params.id;
            this.branchList();
            if(id !== undefined && id != null && id !== ''){
                let loading = this.$loading.show();
                this.actionLink = 'sale/exchange/update';
                this.$api().post('sale/exchange/find', { Id: id }).then(res => {
                    var data = res.data.Data;
                    this.header = data.SaleQuote;
                    this.lines = data.SaleQuoteLine;
                    this.date = this.$format(this.invoice.Date, 'YYYY-MM-DD');
                    this.due_date = this.$format(this.invoice.DueDate, 'YYYY-MM-DD');
                    this.reCalculate();
                }).finally(function() { loading.hide(); });
            }
        },
        methods: {
            branchList(){
                this.$api().post('branch/list', { CompanyId: this.$store.state.company.Id }).then(res => {
                    if(this.$isValid(res)){
                        this.branchs = res.data.Json.Branches;
                    }
                });
            },
            onSave(){
                const loading = this.$loading.show();
                this.header.Date = this.date;
                this.header.DueDate = this.due_date;
                this.header.CompanyId = this.$store.state.company.Id;
                this.header.ClientId = this.$store.state.company.ClientId;
                const req = {
                    Header: this.header,
                    Lines: this.lines
                };
                this.$api().post(this.actionLink, req).then(res => {
                    if(this.$isValid(res)){this.$router.push('/sale/exchanges');}
                }).finally(function() { loading.hide(); });
            },
            select(item, line){
                line.ItemId = item.Id;
                line.ItemName = item.Name;
                line.UomId = item.UomId;
                line.UomName =  item.UomName;
                line.Discount = item.Discount;
                line.Cost = item.Cost;
                this.reCalculate();
            },
            customerSelected(evt){
                this.header.CustomerId = evt.Id;
                this.header.CustomerName = evt.Name;
                this.header.Phone = evt.Phone;
            },
            reCalculate(){
                let grand = 0;
                this.lines.map(item => {
                    item.SubTotal = (item.Quantity * item.Cost) - (item.Quantity * item.Cost * item.Discount / 100);
                    grand += item.SubTotal;
                });
                this.header.TotalAmount = grand;
                this.header.PaidAmount = grand - (Number(this.header.Discount) + Number(this.header.Deposit));
            },
            addLine(){
                this.lines.push({
                    Checked: false,
                    ItemName: '',
                    Quantity: 1,
                    UomName: '',
                    UomId: '',
                    Cost: 0,
                    Discount: 0,
                    SubTotal: 0
                });
            },
            itemSelect(evt, line){
                line.ItemId = evt.Id;
                line.ItemName = evt.Name;
                line.Price = evt.Price;
                this.reCalculate();
            },
            removeLine(index){
                this.lines.splice(index, 1);
                this.reCalculate();
            },
            uomChange(e, line){
                line.UomId = e.UomId;
                line.UomName = e.UomName;
            },
        }
    }
</script>
<style scoped>
    label{
        margin-bottom: 0;
    }
    .none-left{
        border-left: none;
    }
</style>
